import { render, staticRenderFns } from "./NonLoginBusinessMatchResults.vue?vue&type=template&id=a779f9de&scoped=true"
import script from "./NonLoginBusinessMatchResults.vue?vue&type=script&lang=ts"
export * from "./NonLoginBusinessMatchResults.vue?vue&type=script&lang=ts"
import style0 from "./NonLoginBusinessMatchResults.vue?vue&type=style&index=0&id=a779f9de&prod&lang=scss&scoped=true"
import style1 from "./NonLoginBusinessMatchResults.vue?vue&type=style&index=1&id=a779f9de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a779f9de",
  null
  
)

export default component.exports